import React from 'react';
import BuilderMaskGroupWflBehaviour from '@form-engine/builder-mask/components/groups/wfl-behaviour';
import BuilderStringProperty from '@form-engine/builder-mask/components/properties/string';
import BuilderMaskGroup from '@form-engine/builder-mask/components/mask/group';
import { i18n } from '@form-engine/builder-application';

export function BuilderSessionLogWflSetup() {
    return (
        <>
            <BuilderMaskGroupWflBehaviour />
            <BuilderMaskGroup>
                <BuilderStringProperty
                    label={i18n.c('FormEngineSessionLogWfl.retention')}
                    propertyName="retention"
                    type="number"
                    min="1"
                    max="30"
                    step="1"
                />
            </BuilderMaskGroup>
        </>
    );
}

export default function BuilderHttpRequestWflMask() {
    return <BuilderSessionLogWflSetup />;
}
